var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.067,
    height: 12.069,
    viewBox: "0 0 12.067 12.069",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "time-add",
    transform: "translate(-0.004 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68455",
    "data-name": "Path 68455",
    d: "M18.274,15.76H17.269V14.754a.754.754,0,0,0-1.509,0V15.76H14.754a.754.754,0,0,0,0,1.509H15.76v1.006a.754.754,0,0,0,1.509,0V17.269h1.006a.754.754,0,0,0,0-1.509Z",
    transform: "translate(-6.958 -6.96)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68456",
    "data-name": "Path 68456",
    d: "M5.82,10.555a4.526,4.526,0,1,1,4.737-4.737.755.755,0,0,0,1.509-.07,6.034,6.034,0,1,0-6.316,6.314h.036a.754.754,0,0,0,.035-1.509Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68457",
    "data-name": "Path 68457",
    d: "M9.711,6a.754.754,0,0,0-.754.754V8.542L7.75,9.3a.754.754,0,0,0,.8,1.279L9.994,9.67a1.006,1.006,0,0,0,.472-.855V6.754A.754.754,0,0,0,9.711,6Z",
    transform: "translate(-3.675 -2.983)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeAdd);
export default __webpack_public_path__ + "static/media/time-add.79f2a0bc.svg";
export { ForwardRef as ReactComponent };